import React from 'react';

const VeteranContactInfoDescription = (
  <>
    <p>
      We’ll use the Veteran’s primary phone number to contact them if we need to
      follow up about this application.
    </p>
    <p>
      Providing the Veteran’s email address is optional, but it helps us contact
      them faster.
    </p>
    <p>
      <strong>Note:</strong> We’ll always mail the Veteran a copy of our
      decision on this application for their records.
    </p>
    <p>
      Any updates the Veteran makes here to their contact information will only
      apply to this application.
    </p>
  </>
);

export default VeteranContactInfoDescription;
